// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  useEnvFile: true,
  auth: {
    localStorageKey: 'trust_center_access_token',
    whitelistedDomains: ['localhost:8080', '192.168.11.152:8083', '192.168.11.131:8083']
  },
  endpoints: {
    clientBaseUrl: 'https://192.168.11.148/trustcenter-client-rest',
    login: '/auth',
    logout: '/blacklist',
    changePassword: '/api/v1/user/changepw',
    getUser: '/api/v1/user/{id}',
    userList: '/api/v1/user/list',
    addUser: '/api/v1/user',
    updateUser: '/api/v1/user',
    getActiveTasks: '/api/v1/client/activetasks',
    getQueuedTasks: '/api/v1/client/queuedtasks/{client}/{execProp}',
    taskList: '/api/v1/request/listfilter',
    getTask: '/api/v1/request/{id}',
    taskSnapshot: '/api/v1/request/snapshot/{id}',
    startTask: '/api/v1/request/start/{id}',
    requestDefinitionList: '/api/v1/requestdefinition/list',
    getRequestDefinition: '/api/v1/requestdefinition/{id}',
    approveRequest: '/api/v1/request/approve/{id}',
    denyRequest: '/api/v1/request/deny/{id}',
    cancelRequest: '/api/v1/request/cancel/{id}',
    clientList: '/api/v1/client/list',
    getClientInfo: '/api/v1/client/clientinfo',
    dbSchemas: '/api/v1/client/dbschemas',
    executionProperties: '/api/v1/client/executionproperties',
    protocolList: '/api/v1/protocol/listfilter',
    protocolListAsCsv: '/api/v1/protocol/listfilter/csv',
    severityList: '/api/v1/client/protocolseverities',
    workflowTypeList: '/api/v1/client/workflows',
    createRequestDefinition: '/api/v1/requestdefinition',
    updateRequestDefinition: '/api/v1/requestdefinition',
    updateRequestDefinitionAttributes: '/api/v1/requestdefinition/attributes',
    uploadDocFile: '/api/v1/file/upload/doc',
    uploadInputFile: '/api/v1/file/upload/input',
    downloadDocumentation: '/api/v1/file/download/DOC/{rdId}',
    downloadResults: '/api/v1/file/download/RES/{rdId}/{taskId}',
    updateTask: '/api/v1/request',
    getAvailableRequestDefinitions: '/api/v1/client/requestdefinitions',
    createTask: '/api/v1/request',
    getPermissions: '/api/v1/user/permissions',
    approveRequestDefinition: '/api/v1/requestdefinition/approve/{id}',
    denyRequestDefinition: '/api/v1/requestdefinition/deny/{id}',
    getTransferErrors: '/api/v1/failedtask/list',
    getTransferErrorsFiltered: '/api/v1/failedtask/listfilter',
    startRequestDefinition: '/api/v1/requestdefinition/start/{id}',
    getRequestDefinitionSubtasks: '/api/v1/requestdefinition/subtasks/{id}',
    getRequestSubtasks: '/api/v1/request/subtasks/{id}'
  },
  images: {
    loginLogo: '/assets/images/ims-health-logo.png',
    loginBackground: '/assets/images/login-background.jpg'
  },
  ui: {
    snackbar: {
      duration: 7500,
      verticalPosition: 'top'
    }
  },
  languages: [
    {
      key: 'en',
      displayName: 'English'
    },
    {
      key: 'de',
      displayName: 'Deutsch'
    }
  ],
  roles: {
    admin: 'ROLE_ADMIN',
    anfrager: 'ROLE_ANFRAGER',
    masterAnfrager: 'ROLE_MASTERANFRAGER',
    architekt: 'ROLE_ARCHITEKT',
    pruefer: 'ROLE_PRUEFER'
  },
  navigation: [
    {
      route: 'home',
      translationKey: 'navigation.home.title',
      descriptionTranslationKey: 'navigation.home.description',
      permissions: []
    },
    {
      route: 'requests',
      translationKey: 'navigation.requests.title',
      descriptionTranslationKey: 'navigation.requests.description',
      permissions: ['REQUEST']
    },
    {
      route: 'request-definitions',
      translationKey: 'navigation.requestDefinitions.title',
      descriptionTranslationKey: 'navigation.requestDefinitions.description',
      permissions: ['REQUEST_DEFINITION']
    },
    {
      route: 'log',
      translationKey: 'navigation.log.title',
      descriptionTranslationKey: 'navigation.log.description',
      permissions: ['LOG']
    },
    {
      route: 'transfer-errors',
      translationKey: 'navigation.transactionErrors.title',
      descriptionTranslationKey: 'navigation.transactionErrors.description',
      permissions: ['TRANSACTION_ERRORS']
    },
    {
      route: 'user-admin',
      translationKey: 'navigation.userAdministration.title',
      descriptionTranslationKey: 'navigation.userAdministration.description',
      permissions: ['USER_ADMIN']
    } ,
    {
      route: 'task-info',
      translationKey: 'navigation.taskInfo.title',
      descriptionTranslationKey: 'navigation.taskInfo.description',
      permissions: ['UTIL_REQUESTS']
    }
  ],
  requestStates: [
    {
      key: 'ACTIVE', // Aktive Anfragen
      translationKey: 'requests.filter.states.active'
    },
    {
      key: 'NOT_STARTED', // Noch nicht gestartet
      translationKey: 'requests.filter.states.notStarted'
    },
    {
      key: 'FINISHED', // 0 Beendet
      translationKey: 'requests.filter.states.finished'
    },
    {
      key: 'CANCELLED_ERROR', // -1 Abbruch durch Fehler
      translationKey: 'requests.filter.states.cancelledError'
    },
    {
      key: 'CANCELLED_USER', // -2 Abbruch durch User
      translationKey: 'requests.filter.states.cancelledUser'
    }
  ],
  tables: {
    pageSize: 10,
    pageSizeOptions: [10, 20, 30, 50, 100]
  },
  subTaskUpdateInterval: 5000,
  datePickerLocale: 'de-DE',
  datePickerFormat: {
    parse: {
      dateInput: 'DD.MM.YYYY'
    },
    display: {
      dateInput: 'DD.MM.YYYY',
      monthYearLabel: 'MMMM YYYY',
      dateA11yLabel: 'DD.MM.YYYY',
      monthYearA11yLabel: 'DD-MM-YYYY',
    }
  },
  minPasswordCharacters: 8,
  autoLogoutInterval: 1740
};
